var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column","min-height":"100vh"}},[(_vm.layout)?_c('TransitionedRouter',{key:_vm.layout,attrs:{"layout":_vm.layout}},[_c('RouterView')],1):_vm._e(),_c('portal-target',{attrs:{"name":"image-preview"}}),_c('portal-target',{attrs:{"name":"chat-container"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }